"use client";

import "@puckeditor/core/puck.css";

import { Render } from "@puckeditor/core";
import blogPuckConfig from "@/puck/blogConfig";
import type { BlogPuckData } from "@/puck/types";

type BlogPageRenderProps = {
  data: BlogPuckData;
};

export function BlogPageRender({ data }: Readonly<BlogPageRenderProps>) {
  return <Render config={blogPuckConfig} data={data} />;
}
